import { Feature, GrowthBook } from 'hooks/GrowthBook';
import { isString } from 'lodash';

/**
 * Parse error string for errors returned specifically from useAsync and useAsyncCallback
 * Expects error object in the form of {error: string}
 * @param error
 * @param defaultErrorString
 */
export const parseAsyncError = (
  error: Error,
  defaultErrorString: string,
): string => {
  let errMsg;
  try {
    const parsedError = JSON.parse((error as any).error);
    if (isString(parsedError?.error)) {
      errMsg = parsedError.error;
    } else {
      throw new Error(`Cannot parse error message`);
    }
  } catch (e) {
    errMsg = defaultErrorString;
  }

  return errMsg;
};

type PreviewParams = {
  type: 'blob';
  useDocumentEngine?: boolean;
};
export const getPdfPreviewParams = (growthBook: GrowthBook): PreviewParams => {
  const params: PreviewParams = { type: 'blob' };
  if (
    growthBook.getFeatureValue(Feature.USE_DOCUMENT_ENGINE_FOR_PREVIEW, false)
  ) {
    params.useDocumentEngine = true;
  }
  return params;
};
